export default {
    MUST_EQUIP_AXE: 'Чтобы рубить деревья, необходимо вооружиться топором.',
    MUST_EQUIP_PICKAXE: 'Для добычи камней необходимо использовать кирку.',
    MUST_EQUIP_FISHING: 'Для ловли рыбы необходимо иметь при себе удочку или что-то другое.',
    MUST_EQUIP_FORAGING: 'Для его добычи требуется специальный инструмент',

    INVALID_LEVEL_LUMBERJACKING: 'Вы должны быть {{level}}, чтобы срубить это дерево.',
    INVALID_LEVEL_MINING: 'Для добычи этой породы необходимо иметь уровень {{level}}.',
    INVALID_LEVEL_FISHING: 'Чтобы ловить здесь рыбу, вы должны иметь уровень {{level}}.',
    INVALID_LEVEL_FORAGING: 'Чтобы добыть этот ресурс, необходимо иметь уровень {{level}}.',

    UNABLE_TO_INTERACT_LUMBERJACKING: 'В настоящее время вы не можете спилить это дерево.',
    UNABLE_TO_INTERACT_MINING: 'Вы не обладаете необходимыми знаниями для добычи этой породы.',
    UNABLE_TO_INTERACT_FISHING: 'В настоящее время вы не можете ловить здесь рыбу.',
    UNABLE_TO_INTERACT_FORAGING: 'В настоящее время вы не можете добывать этот ресурс.',

    NO_REASON_TREE: 'Нет никаких причин для того, чтобы спиливать это дерево.',
    NO_REASON_FISH: 'Нет никаких причин для того, чтобы ловить здесь рыбу.'
} as const;
